import React, { useEffect } from 'react';
import { Container, Spinner, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { baseURL } from '../../helpers/baseURL';
import { getUser, setLoading } from '../../redux/actions';

const SwitchWorkspace = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	useEffect(() => {
		let cancelled = false;

		const redirectAfterSwitch = async () => {
			try {
				await new Promise((resolve) => setTimeout(resolve, 1200));
				dispatch(setLoading(true));
				const response = await axios.get(
					`${baseURL}user?timezone=${encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone)}`,
					{
						headers: {
							Authorization: `Bearer ${Cookies.get('access_token')}`,
						},
					}
				);
				if (cancelled) return;
				const user = response.data?.data || response.data;
				dispatch(getUser(user));
				history.push(user?.workspace_locked ? '/workspace/locked' : '/dashboard');
			} catch {
				if (!cancelled) {
					history.push('/dashboard');
				}
			}
		};

		redirectAfterSwitch();

		return () => {
			cancelled = true;
		};
	}, [dispatch, history]);

	return (
		<Container className="py-5">
			<Row>
				<Col className="mt-3 text-center">
					<Spinner animation="border" role="status" />
					<h3 className="mt-3">Switching workspace...</h3>
					<p className="text-muted">Please wait while we load your workspace.</p>
				</Col>
			</Row>
		</Container>
	);
};

export default SwitchWorkspace;
